import { RecommendedArticleItemProp } from '../types'
import { BlogComponentType } from '../../../types'
import * as React from 'react'
import { extractVidoeIdFromYoutubeUrl } from '../../../lib/utils/getEmbedUrlFromYouTubeUrl'
import { UseCaseItem } from './UseCaseItem'
import { CustomerStoriesItem } from './CustomerStoriesItem'
import { NewsTeaserItem } from './NewsTeaserItem'

export const RecommendedArticleItem = ({
  title,
  isListView,
  image,
  component,
  to,
  category,
}: RecommendedArticleItemProp) => {
  let youtubeId = null

  const createImageUrl = url => {
    youtubeId = extractVidoeIdFromYoutubeUrl(url)
    if (youtubeId) {
      return `https://img.youtube.com/vi/${youtubeId}/sddefault.jpg`
    }

    return url
  }
  const ArticleComponent = (): JSX.Element => {
    switch (component) {
      case BlogComponentType.CUSTOMER_STORIES: {
        return (
          <CustomerStoriesItem
            title={title}
            category={category}
            to={to}
            component={BlogComponentType.CUSTOMER_STORIES}
            isSmall={isListView}
            isYoutube={!!youtubeId}
            src={createImageUrl(image?.filename)}
            alt={image?.alt}
          />
        )
      }
      case BlogComponentType.USE_CASE: {
        return (
          <UseCaseItem
            title={title}
            category={category}
            to={to}
            component={BlogComponentType.CUSTOMER_STORIES}
            isSmall={isListView}
            isYoutube={!!youtubeId}
            src={createImageUrl(image.filename)}
            alt={image.alt}
          />
        )
      }
      case BlogComponentType.COMPANY_INSIGHTS:
      case BlogComponentType.PRODUCT_NEWS:
      case BlogComponentType.PDF_KNOWLEDGE:
      default: {
        return (
          <NewsTeaserItem
            title={title}
            category={category}
            to={to}
            component={component}
            isSmall={isListView}
            isYoutube={!!youtubeId}
            src={createImageUrl(image?.filename)}
            alt={image.alt}
          />
        )
      }
    }
  }

  return <ArticleComponent />
}
